import { render, staticRenderFns } from "./EditShortcutV2.vue?vue&type=template&id=199c384c&scoped=true"
import script from "./EditShortcutV2.vue?vue&type=script&lang=js"
export * from "./EditShortcutV2.vue?vue&type=script&lang=js"
import style0 from "./EditShortcutV2.vue?vue&type=style&index=0&id=199c384c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199c384c",
  null
  
)

export default component.exports